import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import blackListApi from '../../../requests/api/black-list';
import Snackbar from '../../../components/Snackbar';

const BlockUserDialog = ({ openDialog, setOpenDialog, userId }) => {
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('');
  const styles = useStyles();
  const { t } = useTranslation();
  const [comment, setComment] = useState('');
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleBlock = async () => {
    const response = await blackListApi.createBlackList({
      userId,
      comment,
    });
    if (response.success) {
      setSeverity('success');
      setMessage(t('blockUserDialog.blocked'));
    } else {
      setSeverity('error');
      setMessage(t('common.savedUnsuccessfully'));
    }
    setOpenDialog(false);
  };

  return <>
    <Dialog open={openDialog} onClose={handleCloseDialog}>
      <DialogTitle>{t('blockUserDialog.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('blockUserDialog.subtitle')}
        </DialogContentText>
        <TextField
          value={comment}
          multiline
          minRows={4}
          variant="outlined"
          onChange={(e) => setComment(e.target.value)}
          placeholder={t('blockUserDialog.placeholder')}
          fullWidth
        />
      </DialogContent>
      <DialogActions className={styles.dialogActions}>
        <Button onClick={() => handleCloseDialog()} className={styles.normalButton}>{t('common.cancel')}</Button>
        <Button onClick={() => handleBlock()} className={styles.blockButton}>{t('blockUserDialog.block')}</Button>
      </DialogActions>
    </Dialog >
    <Snackbar
      open={!!message}
      message={message}
      severity={severity}
      onClose={() => setMessage('')}
    />
  </>;
};

export default BlockUserDialog;
